<template>
  <woot-modal :show.sync="show" :on-close="onClose" size="medium">
    <woot-modal-header :header-title="headerTitle" />
    <div class="participants-modal__body">
      <div v-if="assignedAgent" class="assigned-agent-block">
        <span class="assigned-label">
          {{ $t('CONVERSATION_PARTICIPANTS.ASSIGNED_AGENT') }}
        </span>
        <div class="assigned-agent-info">
          <thumbnail
            :username="assignedAgent.name"
            :src="assignedAgent.thumbnail"
            size="32px"
          />
          <span class="assigned-agent-name">{{ assignedAgent.name }}</span>
        </div>
      </div>
      <div class="participants-list-block">
        <span class="participants-list-label">
          {{ $t('CONVERSATION_PARTICIPANTS.PARTICIPANTS_IN_CONVERSATION') }}
        </span>
        <input
          v-model="search"
          class="participants-search"
          :placeholder="$t('CONVERSATION_PARTICIPANTS.SEARCH_PARTICIPANT')"
        />
        <div class="participants-list">
          <div class="participants-columns">
            <div
              v-for="(column, idx) in columns"
              :key="idx"
              class="participants-column"
            >
              <div
                v-for="user in column"
                :key="user.id"
                class="participant-row"
              >
                <thumbnail
                  :username="user.name"
                  :src="user.thumbnail"
                  size="32px"
                />
                <span class="participant-name">{{ user.name }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </woot-modal>
</template>

<script>
import Thumbnail from 'dashboard/components/widgets/Thumbnail';

export default {
  name: 'ParticipantsModal',
  components: { Thumbnail },
  props: {
    show: { type: Boolean, default: false },
    participants: { type: Array, default: () => [] },
    assignedAgent: { type: Object, default: null },
    onClose: { type: Function, required: true },
  },
  data() {
    return {
      search: '',
    };
  },
  computed: {
    /** Retorna el título traducido del modal de participantes con el conteo actual. */
    headerTitle() {
      return this.$t('CONVERSATION_PARTICIPANTS.PARTICIPANTS_MODAL_TITLE', {
        count: this.filteredParticipants.length,
      });
    },

    /** Filtra y ordena los participantes alfabéticamente según la búsqueda. */
    filteredParticipants() {
      const q = this.search.trim().toLowerCase();
      const filtered = q
        ? this.participants.filter(u => u.name.toLowerCase().includes(q))
        : this.participants;
      return filtered.sort((a, b) => a.name.localeCompare(b.name));
    },

    /** Divide los participantes filtrados en tres columnas equilibradas. */
    columns() {
      const cols = [[], [], []];
      const total = this.filteredParticipants.length;
      const itemsPerColumn = Math.ceil(total / 3);

      this.filteredParticipants.forEach((user, i) => {
        const columnIndex = Math.floor(i / itemsPerColumn);
        if (columnIndex < 3) cols[columnIndex].push(user);
      });
      return cols;
    },
  },
};
</script>

<style scoped>
.participants-modal__body {
  padding: var(--space-normal) var(--space-large);
}
.assigned-agent-block {
  border-radius: var(--border-radius-normal, 8px);
  margin-bottom: var(--space-normal);
}
.assigned-label {
  font-weight: var(--font-weight-bold, 600);
  font-size: var(--font-size-small, 14px);
  margin-bottom: var(--space-small, 8px);
  display: block;
  letter-spacing: 0.5px;
  color: var(--conversa2-blue-700-color);
}
.assigned-agent-info {
  display: flex;
  align-items: center;
  gap: var(--space-slab, 12px);
}
.assigned-agent-name {
  font-weight: var(--font-weight-bold, 600);
  font-size: var(--font-size-default, 16px);
  color: var(--conversa2-neutral-800-color);
  line-height: 24px;
  letter-spacing: 0px;
}
.participants-list-block {
  margin-top: 0;
}
.participants-list-label {
  color: var(--conversa2-blue-700-color);
  font-weight: var(--font-weight-semibold, 600);
  font-size: var(--font-size-small, 14px);
  margin-bottom: var(--space-smaller, 4px);
  display: block;
}
.participants-search {
  width: 100%;
  margin-bottom: var(--space-normal, 16px);
  padding: var(--space-small, 8px) var(--space-slab, 12px);
  border: 1px solid #e5e7eb;
  border-radius: var(--border-radius-normal-small, 6px);
  font-weight: var(--font-weight-normal, 400);
  font-size: var(--font-size-small, 14px);
  line-height: var(--space-two, 20px);
  letter-spacing: 0px;
  vertical-align: middle;
  background: #f9fafb;
  outline: none;
  transition: all 0.2s ease;
}
.participants-search:focus {
  border-color: #1b67ac;
  background: white;
}
.participants-search::placeholder {
  color: #9ca3af;
}
.participants-list {
  width: 100%;
  max-height: 400px;
  overflow-y: auto;
  overflow-x: hidden;
}
.participants-columns {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: var(--space-small, 8px);
  width: 100%;
}
.participants-column {
  min-width: 0;
  max-width: 100%;
}
.participant-row {
  display: flex;
  align-items: center;
  gap: var(--space-slab, 12px);
  padding: var(--space-smaller, 4px);
  border-radius: var(--border-radius-normal-small, 4px);
}
.participant-row:hover {
  background-color: #f9fafb;
}
.participant-name {
  font-weight: var(--font-weight-normal, 400);
  font-size: var(--font-size-default, 16px);
  line-height: var(--space-medium, 24px);
  letter-spacing: 0px;
  vertical-align: middle;
  color: var(--conversa2-neutral-800-color);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
